module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('modal', {
    ref: "modal"
  }, [_c('span', {
    attrs: {
      "slot": "activator"
    },
    slot: "activator"
  }, [_vm._t("activator")], 2), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_vm._v("Send product to ERP")]), _vm._v(" "), _c('div', {
    staticClass: "header"
  }, [_c('h2', [_vm._t("header")], 2)]), _vm._v(" "), _c('div', {
    staticClass: "toolbar"
  }, [_vm._t("toolbar")], 2), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "infos"
  }, [_c('div', [_vm._v("Order N°" + _vm._s(_vm.order.id_order))]), _vm._v(" "), _c('div', [_vm._v("Product id N° " + _vm._s(_vm.value.id_product))])]), _vm._v(" "), _c('div', {
    staticClass: "erp-form"
  }, [_c('div', {}, [_c('label', {
    attrs: {
      "for": "cutwait"
    }
  }, [_vm._v("To Cut & Wait")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sendERP.cutWait),
      expression: "sendERP.cutWait"
    }],
    staticClass: "ui checkbox",
    attrs: {
      "id": "cutwait",
      "type": "checkbox",
      "name": "cutWait"
    },
    domProps: {
      "checked": Array.isArray(_vm.sendERP.cutWait) ? _vm._i(_vm.sendERP.cutWait, null) > -1 : (_vm.sendERP.cutWait)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.sendERP.cutWait,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.sendERP, "cutWait", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.sendERP, "cutWait", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.sendERP, "cutWait", $$c)
        }
      }
    }
  })]), _vm._v(" "), _c('div', {}, [_c('label', {
    attrs: {
      "for": "measurement"
    }
  }, [_vm._v("New Measurement")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sendERP.measurement),
      expression: "sendERP.measurement"
    }],
    staticClass: "ui checkbox",
    attrs: {
      "id": "measurement",
      "type": "checkbox",
      "name": "measurement"
    },
    domProps: {
      "checked": Array.isArray(_vm.sendERP.measurement) ? _vm._i(_vm.sendERP.measurement, null) > -1 : (_vm.sendERP.measurement)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.sendERP.measurement,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.sendERP, "measurement", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.sendERP, "measurement", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.sendERP, "measurement", $$c)
        }
      }
    }
  })]), _vm._v(" "), _c('div', {}, [_c('label', {
    attrs: {
      "for": "wascutwait"
    }
  }, [_vm._v("Was in Cut & Wait")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sendERP.wasCutWait),
      expression: "sendERP.wasCutWait"
    }],
    staticClass: "ui checkbox",
    attrs: {
      "id": "wascutwait",
      "type": "checkbox",
      "name": "wasCutWait"
    },
    domProps: {
      "checked": Array.isArray(_vm.sendERP.wasCutWait) ? _vm._i(_vm.sendERP.wasCutWait, null) > -1 : (_vm.sendERP.wasCutWait)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.sendERP.wasCutWait,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.sendERP, "wasCutWait", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.sendERP, "wasCutWait", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.sendERP, "wasCutWait", $$c)
        }
      }
    }
  })]), _vm._v(" "), _c('div', [_c('label', [_vm._v("Option")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sendERP.option),
      expression: "sendERP.option"
    }],
    staticClass: "ui selection dropdown",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.sendERP, "option", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    staticClass: "item",
    attrs: {
      "value": "SHIRT_MAKING_STANDARD"
    }
  }, [_vm._v("Normal")]), _vm._v(" "), _c('option', {
    staticClass: "item",
    attrs: {
      "value": "SHIRT_MAKING_PACK"
    }
  }, [_vm._v("Package")]), _vm._v(" "), _c('option', {
    staticClass: "item",
    attrs: {
      "value": "SHIRT_REMAKE"
    }
  }, [_vm._v("Remake")]), _vm._v(" "), _c('option', {
    staticClass: "item",
    attrs: {
      "value": "FREE_REMAKE"
    }
  }, [_vm._v("Free remake")]), _vm._v(" "), _c('option', {
    staticClass: "item",
    attrs: {
      "value": "COLLAR_MAKING"
    }
  }, [_vm._v("Collar only")]), _vm._v(" "), _c('option', {
    staticClass: "item",
    attrs: {
      "value": "CUFF_MAKING"
    }
  }, [_vm._v("Cuff only")])])]), _vm._v(" "), _c('div', {
    staticClass: "ui form"
  }, [_c('label', [_vm._v("Comment")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sendERP.comment),
      expression: "sendERP.comment"
    }],
    domProps: {
      "value": (_vm.sendERP.comment)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.sendERP, "comment", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {}, [(_vm.value.sent_to_erp == 0) ? _c('button', {
    staticClass: "ui button green",
    attrs: {
      "disabled": _vm.loading == true
    },
    on: {
      "click": function($event) {
        _vm.showModal = true
      }
    }
  }, [_vm._v("\n          Send to ERP\n        ")]) : _vm._e(), _vm._v(" "), (_vm.value.sent_to_erp == 1) ? _c('button', {
    staticClass: "ui button yellow",
    attrs: {
      "disabled": _vm.loading == true
    },
    on: {
      "click": function($event) {
        _vm.showModal = true
      }
    }
  }, [_vm._v("\n          Send to ERP\n        ")]) : _vm._e()])])]), _vm._v(" "), _c('popup-modal', {
    ref: "confirmErpModal",
    attrs: {
      "index": _vm.showModal,
      "icon": "checkmark",
      "cancel_class": "ui red basic cancel inverted button",
      "confirm_class": "ui green ok inverted button",
      "text": "Are you sure you want to send this product to the ERP ?"
    },
    on: {
      "delete": function($event) {
        return _vm.sendToERP()
      },
      "cancel": function($event) {
        _vm.showModal = null
      }
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-01b9eb68","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ERPModal.vue
// module id = 477
// module chunks = 1